import React from "react";
import "./Hero.css";

const Hero = () => {
  return (
    <section id="hero">
      <h4>Trade-in-offer</h4>
      <h2>Super value deals</h2>
      <h1>On all products</h1>
      <p>Save more with coupens & upto 70% off! </p>
      <button>Shop Now</button>
    </section>
  );
};

export default Hero;
